import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { FloorNumbersFailure, FloorNumbersRequest, FloorNumbersSuccess } from './actions';
import { FloorNumbersService } from './service';
import { AppState } from '@store/app.state';
import { select, Store } from '@ngrx/store';
import { getData } from './selectors';

@Injectable()
export class FloorNumbersEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly floorNumbersService = inject(FloorNumbersService);

  floorNumbers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FloorNumbersRequest),
      withLatestFrom(this.store.pipe(select(getData))),
      switchMap(([{ parameters }, data]) => {
        if (!data?.length) {
          return this.floorNumbersService.floorNumbers(parameters).pipe(
            map(data => FloorNumbersSuccess({ data })),
            catchError(error => of(FloorNumbersFailure({ error })))
          );
        }
        return of(FloorNumbersSuccess({ data }));
      })
    )
  );

}
